// extracted by mini-css-extract-plugin
export default {"hide":"sYxAp1cpKV77BJITSi_h"};